import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCards, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-cards';
import Karticka from './Karticka';
import { useContext } from 'react';
import { AppContext } from '../routes/Layout';
import pattern from "../assets/svg/kartyswiper_pattern.svg"

const KartySwiper = ({className=''}) => {
    const {cards} = useContext(AppContext);
    return (
        <div className='w-1/2 mobil:w-full'>
            <img src={pattern} alt="" className='absolute w-full left-0 bottom-0' />
            <Swiper
                effect="cards"
                initialSlide={1}
                navigation={{
                    nextEl: '.cards-next',
                    prevEl: '.cards-prev',
                }}
                modules={[EffectCards, Navigation]}
                className={"cardsSwiper "+className}
                cardsEffect={{perSlideRotate:0,perSlideOffset:50,slideShadows:false}}
            >
                {cards.map(card=><SwiperSlide className='drop-shadow-karty rounded-xl' key={card.id}><Karticka {...card} /></SwiperSlide>)}
            </Swiper>
            <button className='reset swiper-button-prev cards-prev'></button>
            <button className='reset swiper-button-next cards-next'></button>
        </div>
    )
}

export default KartySwiper;